import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "team-info-drawer__header" }
const _hoisted_2 = { class: "title mr-auto ellipsis" }
const _hoisted_3 = { class: "reports__item-date" }
const _hoisted_4 = { class: "px-5 pb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "team-info-drawer__section-title" }, "Общая информация", -1)
const _hoisted_6 = { class: "team-info__info-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Трекер", -1)
const _hoisted_8 = { class: "team-info__info-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Статус", -1)
const _hoisted_10 = { class: "team-info__info-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Цель спринта", -1)
const _hoisted_12 = { class: "team-info__info-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Execution", -1)
const _hoisted_14 = { class: "team-info__info-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Дневник", -1)
const _hoisted_16 = { class: "team-info__info-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Контрольная точка", -1)
const _hoisted_18 = { class: "team-info__info-item" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Чек-лист", -1)
const _hoisted_20 = { class: "checkbox-group" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-group__label mt-2" }, "Количественные цели этапа", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-group__label mt-4" }, "Качественные цели этапа", -1)
const _hoisted_23 = { class: "team-info__info-item text" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "team-info-drawer__section-title" }, "Остальное", -1)
const _hoisted_26 = { class: "team-info__info-item text" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Запрос на ресурсы", -1)

import { useProgramsStore } from '@/stores/programs';
import { useUiStore } from '@/stores/ui';
import dayjs from 'dayjs';
import { computed, onMounted } from 'vue';
import TeamStatus from './TeamStatus.vue';
import VUserInfo from './VUserInfo.vue';
import VCheck from './VCheck.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportInfo',
  props: {
    report: null
  },
  emits: [ "toback" ],
  setup(__props: any, { emit }) {

const props = __props as { report: any }




const programsStore = useProgramsStore()
const program = computed(() => programsStore.programs.find(item => item.id === props.report.programId))
const team = computed(() => {
  return program.value?.teams.find(item => item.id === props.report.teamId)
})

const uiStore = useUiStore()
const ignoreItems = [ "Название программы", "Достигнута ли цель спринта", "Состоялась ли встреча с командой"]
const fields = computed(() => {
  const reportFields = Object.entries(props.report.fields).filter(([ key ]) => !ignoreItems.includes(key))
  return reportFields
})

onMounted(() => {
  programsStore.requestChecklist()
})


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        icon: "mdi-chevron-left",
        class: "ml-n2",
        flat: "",
        style: {"opacity":"0.6"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toback')))
      }),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(team)?.name +  ": отчет трекера"), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(dayjs)(__props.report.date ).format("D MMMM")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(VUserInfo, {
          "user-id": __props.report.trackerId
        }, null, 8, ["user-id"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(TeamStatus, {
          "stage-id": __props.report.programStageId,
          date: new Date().toISOString()
        }, null, 8, ["stage-id", "date"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(VCheck, {
          checked: __props.report.fields['Достигнута ли цель спринта'] === 'Да'
        }, null, 8, ["checked"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createTextVNode(" " + _toDisplayString(__props.report.executionScore), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createTextVNode(" " + _toDisplayString(__props.report.diaryScore), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createTextVNode(" " + _toDisplayString(_unref(programsStore).stages.find(item => item.id === __props.report.programStageId)?.name || "-"), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(programsStore).checklists[__props.report.programStageId]?.quantity, (item) => {
            return (_openBlock(), _createBlock(_component_v_checkbox, {
              "model-value": !!__props.report.stageTasks.find((_task) => _task.id === item.id),
              label: item.title,
              "hide-details": ""
            }, null, 8, ["model-value", "label"]))
          }), 256)),
          _hoisted_22,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(programsStore).checklists[__props.report.programStageId]?.quality, (item) => {
            return (_openBlock(), _createBlock(_component_v_checkbox, {
              "model-value": !!__props.report.stageTasks.find((_task) => _task.id === item.id),
              label: item.title,
              "hide-details": ""
            }, null, 8, ["model-value", "label"]))
          }), 256))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (item) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, _toDisplayString(item[0]), 1),
          _createTextVNode(" " + _toDisplayString(item[1]), 1)
        ]))
      }), 256)),
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createTextVNode(" " + _toDisplayString(__props.report.resourceRequest || "-"), 1)
      ])
    ])
  ], 64))
}
}

})